import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  bookingHeaderTitle: {
    marginTop: 8,
    marginBottom: 24,
  },
  agent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  agentName: {
    marginRight: 4,
  },
  avatar: {
    margin: '0 8px',
    [theme.breakpoints.down('xs')]: {
      marginTop: 6,
    },
  },
  showWeeks: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 40,
    marginTop: 8,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  instruction: {
    background: theme.palette.primary.light,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 0px 0px 1px rgba(19, 45, 74, 0.04)',
    borderRadius: 8,
    display: 'flex',
    padding: '8px 8px 8px 0',
    borderLeft: `8px solid ${theme.palette.primary.main}`,
    marginBottom: 24,
  },
  iconInstruction: {
    color: theme.palette.primary.main,
    margin: '0 18px',
  },
  bottom: {
    marginBottom: 32,
  },
  bookingTitle: {
    color: theme.palette.primary.dark,
  },
  containerButton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
  },
  instructionTop: {
    marginTop: 40,
  },
  button: {
    width: 400,
    borderRadius: 8,
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
  contactAgent: {
    fontSize: 16,
    fontWeight: 300,
    lineHeight: '24px',
  },
  bold: {
    margin: '0 4px',
    fontWeight: 500,
  },
  agence: {
    color: theme.palette.secondary.dark,
  },
}))
